import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi.js";
import { store } from "../store";
import appConfig from "../appconfig";
import * as mutationTypes from "../store/mutation-types";

const EmployeeTokenProvider = {
	activateEmployeeDiscountToken(token) {
		BifrostBackendNestApi.put(`/employee-token-request/${token}`, {
			action: "activate",
			tenantId: appConfig.tenantId
		})
			.then((res) => {
				store.commit(mutationTypes.SHOW_EMPLOYEE_DISCOUNT_SUCCESS_MESSAGE, true);
				store.commit(mutationTypes.SET_EMPLOYEE_DISCOUNT_TOKEN, {
					token,
					expiresAt: res.data.expiresAt,
					customerId: res.data.customerData && res.data.customerData.userId
				});
				store.dispatch(mutationTypes.USER_DATA_PERSIST_TOGGLE, true);
				const customerData = res.data.customerData;
				const firstName = customerData.firstName ? customerData.firstName : "";
				const lastName = customerData.lastName ? ` ${customerData.lastName}` : "";
				store.commit(mutationTypes.USER_DATA_SET, {
					email: customerData.email,
					name: customerData.firstName ? `${firstName}${lastName}` : undefined,
					tel: customerData.phone
				});
			}).catch((err) => {
				handleMessages(err.response.data.message);
			});
	},

	updateEmployeeDiscountToken(action) {
		const token = store.getters.employeeDiscountToken && store.getters.employeeDiscountToken.token;
		if(token) {
			BifrostBackendNestApi.put(`/employee-token-request/${token}`, {
				action,
				tenantId: appConfig.tenantId
			}).then(() => {}).catch((err) => {
				handleMessages(err.response.data.message);
			});
			store.commit(mutationTypes.SET_EMPLOYEE_DISCOUNT_TOKEN, null);
		}
	}
};

const handleMessages = (message) => {
	switch (message) {
	case "token-not-found":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.orderDiscount.tokenNotFound"
		);
		break;
	case "token-already-activated":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.orderDiscount.tokenAlreadyActivated"
		);
		break;
	case "token-activation-time-expired":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.orderDiscount.tokenActivationTimeExpired"
		);
		break;
	case "token-not-activated":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.orderDiscount.tokenNotActivated"
		);
		break;
	case "token-expired":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.orderDiscount.tokenExpired"
		);
		break;
	default:
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.orderDiscount.generalTokenError"
		);
	}
};

export default Object.freeze(EmployeeTokenProvider);
